import { useRef, useEffect, useState, useContext } from "react";
import Select from 'react-select';
import { ddStyles } from "../utils/CommonStyles.js";
import FetchUtil from "../utils/FetchUtil";
import UserContext from "../contexts/UserContext";


function PartnerAppSurveyTableRow({ index, partnerKey, buyerKey, handleSubmit, setError, t, setAdd, oddIdx }) {
    const [appSurveyLoaded, setAppSurveyLoaded] = useState(false);
    const [appSurveyOptions, setAppSurveyOptions] = useState([]);
    const [appSurveySelected, setAppSurveySelected] = useState({ name: "appSurveyKey", label: "", value: 0 });
    const canReadRef = useRef(null);
    const [isCanRead, setIsCanRead] = useState(false);
    const canUpdateSupRef = useRef(null);
    const [isCanUpdateSup, setIsCanUpdateSup] = useState(false);
    const canWriteRef = useRef(null);
    const [isCanWrite, setIsCanWrite] = useState(false);
    const canReviewRef = useRef(null);
    const [isCanReview, setIsCanReview] = useState(false);
    const canReadOwnRef = useRef(null);
    const [isCanReadOwn, setIsCanReadOwn] = useState(false);
    const [isSubmit, setIsSubmit] = useState(false);
    const userCtx = useContext(UserContext);
    let userCompanyId = (userCtx.role !== "SiteAdmin") ? userCtx.userCompanyId : 0;

    useEffect(() => {
        fetchPartnerAppSurveys(partnerKey);
    }, []);

    function setAppSurveyValues(appSurveyObj) {
        let appSurveyValue = {};
        let appSurveyOptionList = [];
        if (appSurveyObj && appSurveyObj.length > 0) {
            appSurveyObj.map((aAppSurvey, idx) => {
                appSurveyValue.label = aAppSurvey.surveyDisplayName;
                appSurveyValue.value = aAppSurvey.appSurveyKey;
                appSurveyOptionList.push(appSurveyValue);
                appSurveyValue = {};
            });
            setAppSurveyOptions(appSurveyOptionList);
            if (appSurveyOptionList && appSurveyOptionList.length > 0) {
                setAppSurveySelected({ ...appSurveySelected, label: (appSurveyOptionList[0].label), value: appSurveyOptionList[0].value });
            }
            setAppSurveyLoaded(true);
        }
    }
    const appSurveyHandler = (selectedOption, action) => {
        let appSurveyKey = selectedOption ? selectedOption.value : 0;
        let appSurveyLabel = selectedOption ? selectedOption.label : "";
        setAppSurveySelected({ ...appSurveySelected, label: (appSurveyLabel), value: appSurveyKey });
    }

    function fetchPartnerAppSurveys(partnerKey) {
        setError("");

        setAppSurveyLoaded(false);
        const requestOptions = {
            credentials: "same-origin",
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                source: "web", getAll: true, supplierKey: partnerKey,
                buyerKey: buyerKey, userCompanyId: userCompanyId
            }),
        };
        try {
            FetchUtil.fetchAPI("GetPartnerAppSurveys", "/Service/CompanyService/GetPartnerAppSurveys", requestOptions, retrievePartnerSurveySuccess, retrievePartnerSurveyFail);
        } catch (error) {
            setAppSurveyLoaded(false);
            throw new Error(error.message);
        }
    }

    function retrievePartnerSurveyFail(redirect) {
        setAppSurveyLoaded(false);
        if (redirect) {
            navigate("/");
        }
        setError(t("error.partnerGetAppSurveyFailed"));
    }

    function retrievePartnerSurveySuccess(responseData) {
        let getPartnerAppSurveyResponse;
        if (responseData) {
            getPartnerAppSurveyResponse = responseData.getPartnerAppSurveyResponse;
            if (getPartnerAppSurveyResponse && getPartnerAppSurveyResponse.errorCode === "0") {
                setAppSurveyValues(getPartnerAppSurveyResponse.appSurveyList.slice())
            } else if (getPartnerAppSurveyResponse && getPartnerAppSurveyResponse.errorCode === "114") {
                navigate("/", {
                    state: {
                        errorMessage: t("error.sessionTimeout"),
                    },
                });
            } else if (getPartnerAppSurveyResponse) {
                setError(t("error.error") + " " + getPartnerAppSurveyResponse.errorMessage);
            } else {
                setError(t("error.system.fetch"));
            }
        }
        setAppSurveyLoaded(true);
    }

    const onResponseChange = (event) => {
        //console.log(event.target + "  " + event.target.name + " " + event.target.checked);
        const { name, id } = event.target;
        //event.preventDefault();
        //event.stopPropagation();
        if (name.startsWith("canRead_")) {
            setIsCanRead(event.target.checked);
        } else if (name.startsWith("canWrite_")) {
            setIsCanWrite(event.target.checked);
        } else if (name.startsWith("canReview_")) {
            setIsCanReview(event.target.checked);
        } else if (name.startsWith("canReadOwn_")) {
            setIsCanReadOwn(event.target.checked);
        } else if (name.startsWith("canUpdateSup_")) {
            setIsCanUpdateSup(event.target.checked);
        }
    }

    function submitComplete() {
        setIsSubmit(false);
        setIsCanRead(false);
        setIsCanUpdateSup(false);
        setIsCanWrite(false);
        setIsCanReview(false);
        setIsCanReadOwn(false);
        setAppSurveySelected({ name: "appSurveyKey", label: "", value: 0 });
    }
    function submitRow() {
        setError("");
        setIsSubmit(true);
        let initialValues = {
            partnerKey: partnerKey,
            appSurveyKey: appSurveySelected.value,
            canRead: canReadRef.current.checked,
            takeCorrectiveActionOnSupplier: canUpdateSupRef.current.checked,
            canWrite: canWriteRef.current.checked,
            canReview: canReviewRef.current.checked,
            canReadOwn: canReadOwnRef.current.checked,
        };

        if (!appSurveySelected.value || appSurveySelected.value === 0) {
            setError(t("error.appSurveyNameReqd"));
            setIsSubmit(false);
        } else if (!partnerKey || partnerKey === 0) {
            setError(t("error.suplrReqd"));
            setIsSubmit(false);
        } else {
            handleSubmit(1, initialValues, submitComplete);
        }

    }
    function submitCancel() {
        setError("");
        setAdd(false);
        setIsCanRead(false);
        setIsCanUpdateSup(false);
        setIsCanWrite(false);
        setIsCanReview(false);
        setIsCanReadOwn(false);
        setAppSurveySelected({ name: "appSurveyKey", label: "", value: 0 });
    }
    return (
        <tr key={index}>
            <td className={oddIdx ? "list-td col odd" : "list-td col even"}>
                {appSurveyLoaded ? <Select
                    name="appSurveyKey"
                    options={appSurveyOptions}
                    onChange={appSurveyHandler}
                    placeholder={""}
                    value={appSurveySelected}
                    isSearchable={true}
                    isClearable={true}
                    className="myselect"
                    inputId="appSurveyKey-input"
                    styles={ddStyles}
                />
                    : <></>}
            </td>
            <td className={oddIdx ? "list-td col odd" : "list-td col even"}></td>
            <td className={oddIdx ? "list-td col odd" : "list-td col even"}>
                <input type="checkbox" className="mycheckbox"
                    ref={canReadRef}
                    name={"canRead_0"}
                    id={"canRead_0"}
                    defaultChecked={true}
                    checked={isCanRead}
                    onChange={onResponseChange}
                />
            </td>
            <td className={oddIdx ? "list-td col odd" : "list-td col even"}>
                <input type="checkbox" className="mycheckbox"
                    ref={canUpdateSupRef}
                    name={"canUpdateSup_0"}
                    id={"canUpdateSup_0"}
                    defaultChecked={false}
                    checked={isCanUpdateSup}
                    onChange={onResponseChange}
                />
            </td>
            <td className={oddIdx ? "list-td col odd" : "list-td col even"}>
                <input type="checkbox" className="mycheckbox"
                    ref={canReadOwnRef}
                    name={"canReadOwn_0"}
                    id={"canReadOwn_0"}
                    defaultChecked={true}
                    checked={isCanReadOwn}
                    onChange={onResponseChange}
                />
            </td>
            <td className={oddIdx ? "list-td col odd" : "list-td col even"}>
                <input type="checkbox" className="mycheckbox"
                    ref={canWriteRef}
                    name={"canWrite_0"}
                    id={"canWrite_0"}
                    defaultChecked={true}
                    checked={isCanWrite}
                    onChange={onResponseChange}
                />
            </td>
            <td className={oddIdx ? "list-td col odd" : "list-td col even"}>
                <input type="checkbox" className="mycheckbox"
                    ref={canReviewRef}
                    name={"canReview_0"}
                    id={"canReview_0"}
                    defaultChecked={true}
                    checked={isCanReview}
                    onChange={onResponseChange}
                />
            </td>
            <td className={oddIdx ? "list-td col odd" : "list-td col even"}>{t("page.active")}</td>
            <td className={oddIdx ? "list-td col odd" : "list-td col even"}>
                <div id="submit-spinner"
                    className={isSubmit ? "spinner-border spinner-border-sm text-dark spinner-size" : "spinner-hide"}
                >
                </div>
                {(appSurveyOptions && appSurveyOptions.length > 0) ?
                    (<button className={isSubmit ? "btn btn-primary btn-block me-4 mb-1 pe-none" : "btn btn-primary btn-block me-4 mb-1"} onClick={() => (submitRow())}>{t("page.submit")}</button>)
                    :
                    (<></>)
                }
                <button className={isSubmit ? "btn btn-primary btn-block me-4 mb-1 pe-none" : "btn btn-primary btn-block me-4 mb-1"} onClick={() => (submitCancel())}>{t("page.cancel")}</button>
            </td>
        </tr>
    )

}
export default PartnerAppSurveyTableRow;